import React, { FormEvent, useEffect, useState } from 'react'
import styles from './styles.module.scss'
import Modal from 'react-modal'

import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';

import { TiDelete } from 'react-icons/ti'
import { api } from '../../../../services/api';

type TagProps = {
    updateTagsToSubmit: (tags: Tag[]) => void,
    putTagList: any
}

type Tag = {
    CM_COD_TAG: number,
    CM_TAG: string,
    CM_DESCRICAO?: string
}

export function TagSelection(props: TagProps) {

    useEffect(() => {
        setTagList(props.putTagList.map((tag: any) => ({ CM_TAG: tag.CM_TAG, CM_COD_TAG: tag.CM_COD_TAG })))
    }, [props.putTagList])

    useEffect(() => {
        Modal.setAppElement('body')
    }, [])

    const customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            padding: '0',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: '7px',
            width: '330px',
            overflow: 'visible'
        },
        overlay: {
            zIndex: 1000
        }
    }

    const [modalIsOpen, setIsOpen] = useState(false);


    function addTagToList(tagToAdd: Tag | undefined) {
        let list = tagList
        if (tagToAdd) {
            list.push(tagToAdd)
        }

        setTagList(list)
        props.updateTagsToSubmit(list)
    }

    function handleSubmit(event: FormEvent) {
        event.preventDefault();
    }

    function openModal() {
        setIsOpen(true);
    }

    function closeModal(method: string) {
        setIsOpen(false);
        if (method) {
            setTagList([])
            props.updateTagsToSubmit([])
        }
    }

    const [autoCompleteOptions, setAutoCompleteOptions] = useState<Tag[]>([])

    useEffect(() => {
        api.get('tags_create')
            .then((resp) => setAutoCompleteOptions(resp.data))
    }, [])

    const [, setCodTag] = useState<Tag>()
    const [tagList, setTagList] = useState<Tag[]>([])


    function insertTagsData(novoCodTag: any) {

        let duplicityValidate = tagList.filter(((tag: Tag) => tag.CM_COD_TAG === novoCodTag?.CM_COD_TAG))

        if (novoCodTag?.CM_TAG.length > 0) {
            if (duplicityValidate.length <= 0) {
                setTextFieldValue(null)
                setCodTag({
                    CM_COD_TAG: novoCodTag?.CM_COD_TAG || -1,
                    CM_TAG: novoCodTag?.CM_TAG || '',
                    CM_DESCRICAO: novoCodTag?.CM_DESCRICAO || ''
                })
                addTagToList({
                    CM_COD_TAG: novoCodTag?.CM_COD_TAG || -1,
                    CM_TAG: novoCodTag?.CM_TAG || '',
                    CM_DESCRICAO: novoCodTag?.CM_DESCRICAO || ''
                })
            }
        }
    }

    function removeTagsData(tagId: number) {
        let removeTag = tagList.filter((tag) => tag.CM_COD_TAG !== tagId)
        setTagList(removeTag)
        props.updateTagsToSubmit(removeTag)
    }

    const [, setTextFieldValue] = useState<Tag | null>()

    return (
        <>
            <div className={styles.tagContainer}>
                <div className={styles.addTagsContainer}>
                    <div>
                        <button onClick={openModal} type="button" name="addTag">+ Adicionar tags ao artigo</button>
                    </div>
                    <div className={styles.buttonTagsContainer}>
                        {
                            tagList.map((tag) => {
                                return (
                                    <button className={styles.tagButton} type="button" key={tag.CM_COD_TAG}>{tag.CM_TAG} <TiDelete onClick={() => removeTagsData(tag.CM_COD_TAG)} className={styles.icon} /> </button>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={() => closeModal('')}
                style={customStyles}>
                <form onSubmit={handleSubmit}>
                    <div className={styles.inputContainer}>
                        <Autocomplete
                            options={autoCompleteOptions}
                            getOptionSelected={(option: Tag, value: Tag) => option.CM_COD_TAG === value.CM_COD_TAG}
                            getOptionLabel={(option: Tag) => option.CM_TAG}
                            onChange={(event: any, novoCodTag) => {
                                insertTagsData(novoCodTag)
                            }
                            }
                            noOptionsText={"Tag inexistente"}
                            id="combo-box-demo"
                            autoComplete
                            includeInputInList
                            renderInput={(params) =>
                                <TextField
                                    style={{ maxHeight: '100px' }}
                                    className={styles.TextField}
                                    {...params}
                                    variant="outlined"
                                    placeholder="Pesquise por uma Tag..." />}
                        />
                    </div>
                    <div className={styles.modalTagsContainer}>
                        {tagList.map((tag) => {
                            return (
                                <>
                                    <button type="button" key={tag.CM_COD_TAG}>{tag.CM_TAG} <TiDelete onClick={() => removeTagsData(tag.CM_COD_TAG)} className={styles.icon} /> </button>

                                    <div className={styles.selectedTagContainer}>
                                        <div className={styles.popupTags}>
                                            <span>{tag.CM_DESCRICAO?.replaceAll("\"", " ")}</span>
                                        </div>
                                    </div>
                                </>
                            )
                        })
                        }
                    </div>
                    <div className={styles.modalConfirmContainer}>
                        <button onClick={() => closeModal('cancelar')} type="button">Cancelar</button>
                        <button type="button" onClick={() => closeModal('')}>Confirmar</button>
                    </div>
                </form>
            </Modal>
        </>
    )
}